'use strict'
const peticiones = require('trae')
const axios = require('axios')
const ruta = process.env.NODE_ENV === 'production' ? 'https://recarga-te.com'
  : process.env.NODE_ENV === 'productionCam' ? 'https://recargasasec.com'
    : 'http://localhost:8091'


//https://recarga-te.com
//http://localhost:8091


function token() {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.token}`
}




export function validaToken() {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/api/validaToken', {},{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function iniciarSesion(username, password, empresa) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/iniciarSesion', {
      username,
      password,
      empresa
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function iniciarSesionVerificada(username, password, code, empresa, latitude, longitude) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/api/2fa/verify', {
      username,
      password,
      code,
      empresa,
      latitude,
      longitude
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function crearNuevoQR(username, password, empresa) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/api/2fa/setup', {
      username,
      password,
      empresa
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function recargar(telefono,compania,monto,plataforma) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/checkOut', {icc:telefono.icc,dn:telefono.dn,compania,monto},{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function recargaSinUsuario(telefono,compania) {
  return new Promise((resolver, rechazar) => {
    peticiones.post( `${ruta}/checkOut/${compania}/recargaSinUsuario`, {icc:telefono.icc,dn:telefono.dn,compania}
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function configRecargasSinUsuario(config) {
  return new Promise((resolver, rechazar) => {
    peticiones.post( `${ruta}/api/configRecargasSinUsuario`, config,{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function reciclarLineas({dnReciclar}) {
  return new Promise((resolver, rechazar) => {
    peticiones.post( `${ruta}/api/dnReciclar/${dnReciclar}`,{},{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}
export function olvidarLineaReciclada({dnReciclar}) {
  return new Promise((resolver, rechazar) => {
    peticiones.post( `${ruta}/api/recicladas/pendientesPorReciclar/${dnReciclar}`,{},{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function recargaExterna(telefono,compania,monto,plataforma) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/foreignCheckOut', {icc:telefono.icc,dn:telefono.dn,compania,monto,plataforma,folio:telefono.folio,type:telefono.type,id:telefono.id},{
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function registrarUsuario(username, nombre, password, nivel, lider, cliente, maxRecargas, phoneNumber, latitude, longitude, code) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/registrarUsuario', {username, nombre, password, nivel, lider, cliente, maxRecargas, phoneNumber, latitude, longitude, code},{
        headers: {
          authorization: `Bearer ${localStorage.token}`
        }
      }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function editarUsuario(nombre, password, nivel, id, lider, cliente, maxRecargas, phoneNumber, latitude, longitude, code) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/editarUsuario', {nombre, password, nivel, id, lider, cliente, maxRecargas, phoneNumber, latitude, longitude, code},{
        headers: {
          authorization: `Bearer ${localStorage.token}`
        }
      }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function eliminarUsuario(id, latitude, longitude, code) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/eliminarUsuario', {id, latitude, longitude, code},{
        headers: {
          authorization: `Bearer ${localStorage.token}`
        }
      }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}


export function subirArchivo(formData) {
  token()


  return axios.post(ruta +`/subirArchivo`,formData, {
    headers: {
      authorization: `Bearer ${localStorage.token}`,
    }
  })
}

export function getIccs(count, offset, diaIni, mesIni, anioIni, diaFin, mesFin, anioFin) {
  let params = {
    diaIni, mesIni, anioIni, diaFin, mesFin, anioFin
  }
  if(count)
    params = {
      ...params,
      count, offset
    }
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/iccs',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },

      params: params

    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getUsuarios() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/api/usuarios',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getUsuariosMonto() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/api/usuariosMonto',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function setUsuariosMonto(username, isMonto) {

  token()
  return axios.post(ruta + '/api/setUsuariosMonto', {
    username, isMonto
  })
}

export function getReportes(diaIni,mesIni,anioIni,diaFin,mesFin,anioFin, idLider,plataforma) {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/reportes',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },
      params:{diaIni, mesIni, anioIni, diaFin, mesFin, anioFin, idLider,plataforma}
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getReportesNew(diaIni,mesIni,anioIni,diaFin,mesFin,anioFin, idLider,plataforma) {
  const rutaReportes = process.env.NODE_ENV === 'production' ? 'https://recargasasec.com' : 'http://localhost:8091'

  return new Promise((resolver, rechazar) => {
    peticiones.get(rutaReportes + '/reportesNew',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },
      params:{diaIni, mesIni, anioIni, diaFin, mesFin, anioFin, idLider,plataforma}
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getReportesNewAsec(diaIni,mesIni,anioIni,diaFin,mesFin,anioFin, idLider,plataforma) {
  const rutaReportes = process.env.NODE_ENV === 'productionCam' ? 'https://recargasasec.com' : 'http://localhost:8091'

  return new Promise((resolver, rechazar) => {
    peticiones.get(rutaReportes + '/reportesNewAsec',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },
      params:{diaIni, mesIni, anioIni, diaFin, mesFin, anioFin, idLider,plataforma}
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}



export function getMovimientos() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/movimientos',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}


export function quienSoy(id) {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/quienSoy',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getCompanias() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/companias').then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function actualizarIcc(id,icc,dn,compania,lider,monto, cliente, nir, latitude, longitude, googleCode) {
  return new Promise((resolver, rechazar) => {
    peticiones.post(ruta + '/actualizarIcc', {id,icc,dn,compania,lider,monto, cliente, nir, latitude, longitude, googleCode},{
        headers: {
          authorization: `Bearer ${localStorage.token}`
        }
      }
    ).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function patchMinimos(minimos) {
  token()
  return axios.patch(ruta + '/minimos',{minimos})
}

export function getMinimos() {
  token()
  return axios.get(ruta + '/minimos')
}

export function getSaldos() {
  token()
  return axios.get(ruta + '/saldosData')
}

export function getEmpresas() {
  token()
  return axios.get(ruta + '/empresas')
}

export function plataformasEmpresa() {

  token()
  return axios.get(ruta + '/plataformasEmpresa')
}

export function plataformaCarrier() {

  token()
  return axios.get(ruta + '/plataformaCarrier')
}


export function cambiarEmpresa(no) {
  console.log(no)
  token()
  return axios.post(ruta + '/cambiarEmpresa', {
    no
  })
}
export function mostrarPendientesDeReciclar() {
  console.log("trayendo pendientes")
  token()
  return axios.get(ruta + '/api/recicladas/pendientesPorReciclar')
}

export function cambiarPlataformasEmpresa(carrier, empresaPlataformaId) {

  token()
  return axios.post(ruta + '/cambiarPlataformasEmpresa', {
    carrier,
    empresaPlataformaId
  })
}

export function addPlataformasEmpresa(username, plataforma, canal) {

  token()
  return axios.post(ruta + '/plataformasEmpresa', {
    username,
    plataforma,
    canal
  })
}



export function creaExcel(filtros, tipo, fechas) {
console.log(filtros, tipo, fechas)
  token()
  return axios.post(`${ruta}/excel`,{
    filtros, tipo, fechas
  },{
    timeout:10*60*1000
  })
}


export function creaExcelCam(filtros, tipo, fechas) {
  const rutaReportes = process.env.NODE_ENV === 'production' ||  process.env.NODE_ENV === 'productionCam' ? 'https://recargasasec.com' : 'http://localhost:8091'
  token()
  return axios.post(`${rutaReportes}/excel`,{
    filtros, tipo, fechas
  },{
    timeout:10*60*1000
  })
}


export function getEmpresa(empresa) {
  console.log(ruta, process.env.NODE_ENV)
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/getEmpresa/'+empresa).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getPermisos() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/api/permisos',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      },
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function getBloquesRecargasMasivas() {
    token()
    return axios.get(ruta + '/api/bloqueRecargasMasivas')
}

export function getRecargasMasivas(fecha) {
    token()
    return axios.get(ruta + '/api/recargasMasivas', {params:{fecha}})
}

export function apiRecargarBloque(fecha) {
  return axios.post(ruta + '/api/recargarBloque', {fecha})
}

export function apiRecargaIndividual(id) {
  token()
  return axios.post(ruta + '/api/recargarIndividual', {id})
}

export function setTheme(document, primaryColor, darkenColor, accentColor){
  let style = document.createElement('style')
  style.innerHTML = `
                            .dropdown-content li>a, .dropdown-content li>span{
    color: ${primaryColor};
  }
  
  .progress .indeterminate {
    background-color: ${primaryColor};
  }
  
  .collection-item:hover{
    background-color: #149183 !important;
    color: white !important;

}
  
  .input-field .prefix.active {
    color: ${primaryColor};
  }

  .input-field input[type]:focus {
    border-bottom: 1px solid ${primaryColor} !important;
    box-shadow: 0 1px 0 0 ${primaryColor} !important;
  }

  .input-field input[type]:focus + label {
    color: ${primaryColor} !important;
  }

  .select-wrapper input.select-dropdown{
    border-bottom: 2px solid ${primaryColor} !important;
  }

  .blue-grey.darken-2{
    background-color: ${primaryColor} !important;
  }

  .blue-grey.darken-1{
    background-color: ${primaryColor} !important;
  }

  .blue-grey.darken-3{
    background-color: ${darkenColor} !important;
  }
  .primary-color{
    background-color: ${primaryColor} !important;
  }
  .datepicker-date-display{
  background-color: ${primaryColor} !important;
  }
  .datepicker-table{
    color: black;
  }
  .datepicker-table td.is-selected{
    background-color: ${primaryColor} !important;
  }
  .datepicker-cancel, .datepicker-clear, .datepicker-today, .datepicker-done{
      color: ${primaryColor} !important;
}                
    .timepicker-digital-display{
    background-color: ${primaryColor} !important;
  }
  .timepicker-close{
      color: ${primaryColor} !important;
  }
  .timepicker-canvas line{
        stroke: ${primaryColor} ;
  }
  .timepicker-canvas-bg{
    fill: ${primaryColor} ;
  }
  .timepicker-canvas-bearing{
          background-color: ${primaryColor} !important;
  }
`

  document.head.appendChild(style)
}


export function getLideres() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/api/lideres',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}


export function getClientes() {
  return new Promise((resolver, rechazar) => {
    peticiones.get(ruta + '/api/clientes',{
      headers: {
        'authorization': `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function renuevaToken() {
  return new Promise((resolver, rechazar) => {
    token()
    axios.post(ruta + '/api/renuevaToken').then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export  function apiChangeTime(data) {
  return new Promise((resolver, rechazar) => {
    token()
    peticiones.post(ruta + '/api/cambiaTiempoAutomatico',data, {
      headers: {
        authorization: `Bearer ${localStorage.token}`
      }
    }).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export function apiGetRecargasProgramadas() {
  return new Promise((resolver, rechazar) => {
    token()
    axios.get(ruta + '/api/getRecargasProgramadas').then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}

export  function apiCancelarProgramacion(data) {
  return new Promise((resolver, rechazar) => {
    token()
    axios.post(ruta + '/api/cancelarProgramacion',data).then(respuesta => resolver(respuesta.data)).catch(error => rechazar(error.data))
  })
}
